function stickyHeader() {
  // Sticky header, mobile only
  const header = document.querySelector('.header');
  if (header && window.matchMedia('(max-width: 767px)').matches) {
    // Add class to header when sticky
    const observer = new IntersectionObserver( 
      ([e]) => e.target.classList.toggle("header--is-sticky", e.intersectionRatio < 1),
      { threshold: [1] }
    );
    observer.observe(header);
    
    // Detect when scrolling down or up
    // https://stackoverflow.com/questions/31223341/detecting-scroll-direction
    var lastScrollTop = 0;
    function headerScroll() {
      var st = window.pageYOffset || document.documentElement.scrollTop;
      if (st > lastScrollTop  && st > 190){
        header.classList.remove('header--visible');
        header.classList.add('header--hidden');
      } else {
        header.classList.remove('header--hidden');
        header.classList.add('header--visible');
      }
      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }

    // Add throttling and accessibilty for sticky header
    // https://css-tricks.com/creating-a-smart-navbar-with-vanilla-javascript/#performance
    var throttleTimer;

    const throttle = (callback, time) => {
      if (throttleTimer) return;

      throttleTimer = true;
      setTimeout(() => {
        callback();
        throttleTimer = false;
      }, time);
    };

    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

    window.addEventListener("scroll", () => {
      if (mediaQuery && !mediaQuery.matches) {
        throttle(headerScroll, 250);
      }
    });
  }
}

export default stickyHeader;
